import { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import '../Analitos.scss';
import DataGrid, { Column, Button as Butt, Editing, RequiredRule, Form } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../../api/api.configuration';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import Popup from 'devextreme-react/popup';
import { useScreenSize } from '../../../utils/media-query';
import { Item } from 'devextreme-react/form';

export const UnitMeasurementBase = ({ visible, setVisible, onUpdate }) => {
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const dataRef = useRef<DataGrid>(null);
  const { newUnitBase, setUnitBase, deleteUnitBase, getUnitsBase } = useApiConfiguration();
  const [unitBase, setUnitBases] = useState();

  const UpdataData = useCallback(() => {
    getUnitsBase().then((res) => {
      setUnitBases(res);
    });
  }, []);

  useEffect(() => {
    UpdataData();
  }, [setUnitBases]);

  const handleVisible = useCallback(() => {
    setVisible(false);
    onUpdate();
  }, [onUpdate, setVisible]);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Umb_Id',
      load() {
        return Promise.resolve({
          data: unitBase,
        }).catch(() => {
          throw new Error('Error de carga de datos');
        });
      },
      insert: async (values) => {
        return newUnitBase({ UnidadBase: values })
          .then((res) => {
            if (res === 105) {
              UpdataData();
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el tipo de muestra');
          });
      },
      update: (key, values) => {
        return setUnitBase({ Unidad: values, IdUnidadBase: key })
          .then((res) => {
            if (res === 107) {
              UpdataData();
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error actualizando la unidad de medida');
          });
      },
      remove: (key) => {
        return deleteUnitBase({ IdUnidadBase: key })
          .then((res) => {
            if (res === 107) {
              UpdataData();
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error eliminando la unidad de medida');
          });
      },
    });
  }, [unitBase]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  return (
    <div>
      <Popup width={1200} height={'50%'} fullScreen={isMedium || isSmall || isXSmall} visible={visible} onHidden={handleVisible} title={'UNIDADES DE MEDIDA BASE'} showTitle={true} showCloseButton={true}>
        <DataGrid dataSource={customDataSrc} ref={dataRef}>
          <Editing mode='form' allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true} texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar', addRow: 'Agregar' }}>
            <Form>
              <Item dataField='Umb_Nombre' />
              <Item dataField='Umb_BaseConversion' />
            </Form>
          </Editing>
          <Column allowGrouping={false} caption='ID' dataField='Umb_Id' alignment='center' visible={true} allowEditing={false} />
          <Column allowGrouping={false} caption='UNIDAD' dataField='Umb_Nombre' alignment='center' visible={true} allowEditing={true}>
            <RequiredRule />
          </Column>
          <Column allowGrouping={false} caption='BASE CONVERSIÓN' visible={true} allowEditing={true} dataField='Umb_BaseConversion' alignment='center' dataType='number'>
            <RequiredRule />
          </Column>
          <Column type='buttons' caption={'ACCIÓN'} width={100}>
            <Butt name='edit' />
            <Butt name='delete' />
          </Column>
        </DataGrid>
      </Popup>
    </div>
  );
};
